module.exports = __webpack_public_path__ + "static/media/71.f6945c6d.png";